import { stringParam } from '@blockit/web-shared/router/searchCodec';
import { LogoutPage } from '@features/auth/components/LogoutPage';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

export const Route = createFileRoute('/logout')({
  validateSearch: z.object({ next: stringParam }),
  component: LogoutPage,
});
